import { TabComponent } from './tab/tab.component';
import { TabsComponent } from './tabs.component';

export const TABS_COMPONENTS = [TabsComponent, TabComponent] as const;

export { TabComponent, TabsComponent };
export type { TabsAppearance } from './tabs.type';
